import React from "react";

import { Typography } from "@packages/ds";
import moment from "moment";

import { Link as DownloadLink } from "ds/Button";
import * as Table from "ds/Table";
import { formatAsCurrency } from "Libs/utils";

import * as S from "./InvoicesPage.styles";

type InvoiceType = {
  id: string;
  invoice_url: string;
  total: number;
  currency: string;
  billing_period_end: string;
  billing_period_start: string;
};

const PastInvoices = ({
  previousOrders,
  setShowInvoice,
  setPastInvoicesView,
  setInvoiceStatus
}) => {
  const pastInvoicesGroupedByYear = previousOrders?.reduce(
    (result, invoice) => {
      const year = moment(invoice.billing_period_start).year();
      if (!result[year]) {
        result[year] = [];
      }
      result[year].push(invoice);

      return result;
    },
    {}
  );

  const handleSelectInvoice = invoice => {
    setPastInvoicesView(false);
    setShowInvoice(invoice);
    setInvoiceStatus(invoice.status);
  };

  return (
    <S.TablesListWrapper>
      {Object.entries(pastInvoicesGroupedByYear)
        ?.sort(([yearA], [yearB]) => parseInt(yearB) - parseInt(yearA))
        .map(([year, invoices]) => (
          <S.TableList key={year}>
            <S.TableHeader>
              <Table.Th width="20%">
                <Typography.BodyText weight="bold">{year}</Typography.BodyText>
              </Table.Th>
            </S.TableHeader>
            <Table.Tbody>
              {(invoices as InvoiceType[])?.map(invoice => (
                <Table.Tr
                  key={invoice.id}
                  onClick={() => {
                    handleSelectInvoice(invoice);
                  }}
                >
                  <Table.Td width="25%">
                    {" "}
                    <Typography.BodyText weight="semiBold">
                      {invoice.id}
                    </Typography.BodyText>
                  </Table.Td>
                  <Table.Td width="50%">
                    <S.InvoiceInterval>
                      {`${moment(invoice.billing_period_start).format(
                        "MMM D, YYYY"
                      )} -
                      ${moment(invoice.billing_period_end)
                        .endOf("month")
                        .format("MMM D, YYYY")}`}
                    </S.InvoiceInterval>
                  </Table.Td>
                  <Table.Td width="25%">
                    <Typography.BodyText weight="semiBold">
                      {formatAsCurrency(invoice.total, invoice.currency)}
                    </Typography.BodyText>
                  </Table.Td>

                  <S.DownloadContainer width="5%">
                    <DownloadLink
                      analyticId="download"
                      href={invoice?.invoice_url}
                      target="_blank"
                      onClick={e => {
                        e.stopPropagation();
                      }}
                    >
                      <S.DownloadIcon />
                    </DownloadLink>
                  </S.DownloadContainer>
                </Table.Tr>
              ))}
            </Table.Tbody>
          </S.TableList>
        ))}
    </S.TablesListWrapper>
  );
};

export default PastInvoices;
